// extracted by mini-css-extract-plugin
export var borderRadius = "_4x-4";
export var large = "_4x-3";
export var logoContainer = "_4x-0";
export var nameLogo = "_4x-2";
export var small = "_4x-1";